<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline"
      @keydown.native.enter="$emit('search', formInline)">
      <el-form-item label="批次包编码">
        <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="包编码" style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="移库状态">
        <el-select v-model="formInline.transferStatus" placeholder="移库状态" style="width:150px">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="待确认" :value="0"></el-option>
          <el-option label="调拨确认" :value="1"></el-option>
          <el-option label="调拨驳回" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="移库时间">
        <el-date-picker v-model="formInline.date" @change="dateChange" type="datetimerange"
          :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="移库确认时间">
        <el-date-picker v-model="formInline.confirmDate" @change="confirmDateChange" type="datetimerange"
          :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="源库区">
        <el-select v-model="formInline.sourceRegion" placeholder="请选择源库区" filterable  style="width:150px">
          <el-option :label="'全部'" :value="undefined"></el-option>
          <el-option :label="item.regionName" :value="item.regionCode" v-for="item in regionList"
            :key="item.regionCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标库区">
        <el-select v-model="formInline.targetRegion" placeholder="请选择目标库区" filterable  style="width:150px">
          <el-option :label="'全部'" :value="undefined"></el-option>
          <el-option :label="item.regionName" :value="item.regionCode" v-for="item in regionList"
            :key="item.regionCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="$emit('search', formInline)">搜索</el-button>
        <el-button style="margin-left: 10px" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" @click="toExport">导出</el-button>
      <el-button type="primary" @click="exportLastDay">导出昨日</el-button>
      <el-button type="primary" @click="exportLastWeek">导出上周</el-button>
    </div>
  </div>
</template>

<script>
import { RegionList, exportTransferLastDay, exportTransferLastWeek, exportTransfer } from "@/apis/inventoryDetails";
export default {
  name: "From",
  props: {
    selRow:{
      type:Array,
      default:[]
    }
  },
  data() {
    return {
      formInline: {},
      date: null,
      regionList: []
    }
  },
  mounted() {
    this.getRegion()
    this.$emit('search', this.formInline)
  },
  methods: {
    getRegion() {
      RegionList().then(({ code, data }) => {
        if (code === 0) {
          this.regionList = data;
        }
      });
    },
    dateChange: function (date) {
      console.log(date)
      if (!date) {
        this.date = null
        this.formInline.startTime = undefined
        this.formInline.endTime = undefined
        return
      }
      this.formInline.startTime = date[0]
      this.formInline.endTime = date[1]
    },
    confirmDateChange: function (date) {
      console.log(date)
      if (!date) {
        this.date = null
        this.formInline.confirmTimeBegin = undefined
        this.formInline.confirmTimeEnd = undefined
        return
      }
      this.formInline.confirmTimeBegin = date[0]
      this.formInline.confirmTimeEnd = date[1]
    },
    rest: function () {
      this.formInline = {}
      this.$emit('search', this.formInline)
    },
    toExport() {
      let params 
      if (this.selRow.length) {
        params = {transferCodes:this.selRow.map(item=>{return item.transferCode})}
      } else {
        params = {
          ...this.formInline
        }
        this.formInline.sourceRegion ? params.sourceName = this.regionList.filter(item => item.regionCode == this.formInline.sourceRegion)[0].regionName : ''
        this.formInline.targetRegion ? params.targetName = this.regionList.filter(item => item.regionCode == this.formInline.targetRegion)[0].regionName : ''
      }
      exportTransfer(params).then(res => {
        if (res.success) {
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
    },
    exportLastDay() {
      exportTransferLastDay().then(res => {
        if (res.success) {
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
    },
    exportLastWeek() {
      exportTransferLastWeek().then(res => {
        if (res.success) {
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
    }
  }
}
</script>

<style scoped></style>